import { AlertTriangle, RefreshCw } from "lucide-react";

export type ErrorStateCode = "BOOTSTRAP_FAILED" | "NETWORK" | "CSP" | "UNKNOWN";

interface Props {
  message: string;
  onRetry?: () => void;
  onBack?: () => void;
  code?: ErrorStateCode;
}

export default function ErrorState({ message, onRetry, onBack, code }: Props) {
  const heading =
    code === "NETWORK"
      ? "Verbindung nicht verfügbar."
      : code === "CSP"
      ? "Dieses Widget kann auf dieser Seite nicht angezeigt werden."
      : code === "BOOTSTRAP_FAILED"
      ? "Etwas ist schiefgelaufen."
      : "Berechnung fehlgeschlagen";

  return (
    <div
      className="flex flex-col items-center justify-center py-12 text-center animate-fade-in"
      role="alert"
      aria-live="assertive"
    >
      <AlertTriangle className="w-12 h-12 text-neko-red mb-4" />
      <h3 className="text-neko-white font-semibold mb-2">{heading}</h3>
      <p className="text-neko-gray text-sm max-w-xs mb-6">{message}</p>
      <div className="flex gap-3">
        {onRetry && (
          <button
            onClick={onRetry}
            className="flex items-center gap-2 bg-neko-orange text-neko-dark font-bold py-2 px-4 rounded-lg text-sm hover:bg-neko-orange-dark transition-all"
          >
            <RefreshCw className="w-4 h-4" /> Erneut versuchen
          </button>
        )}
        {onBack && (
          <button
            onClick={onBack}
            className="flex items-center gap-2 border border-neko-dark-3 text-neko-gray py-2 px-4 rounded-lg text-sm hover:text-neko-white transition-all"
          >
            Zurück
          </button>
        )}
      </div>
    </div>
  );
}
